const SEAT_STATUS = {
  'active': 1,
  'paused': 2,
  'unprotected': 3,
  'archived': 4,
  'unprotecting': 5,
}

const SEAT_STATUS_ACTIONS = {
  'active': 'protect',
  'paused': 'pause',
  'unprotected': 'unprotect',
}

const getEnumLabel = (value, t) => {
  const key = Object.keys(SEAT_STATUS).find(k => SEAT_STATUS[k] === value);

  return t(`common.${key}`);
}

const getAlternativesForStatus = status => {
  switch (status) {
    case 1:
      return [2, 3];
    case 2:
      return [1, 3];
    case 3:
      return [1];
    case 4:
      return [3];
    default:
      return [];
  }
};

const getDataSetLabel = (label, t) => {
  if (label === 0) {
    return t('common.contact');
  } else if (label === 1) {
    return t('common.Calendar');
  } else if (label === 2) {
    return t('recovery.exports.dataSets.mail');
  } else if (label === 3) {
    return t('common.Drive');
  } else if (label === 4 || label === 11) {
    return t('recovery.exports.dataSets.conversations');
  } else if (label === 5) {
    return t('recovery.exports.dataSets.list');
  } else if (label === 7) {
    return t('recovery.exports.dataSets.tasks');
  } else if (label === 8) {
    return t('recovery.exports.dataSets.tasks');
  } else if (label === 9) {
    return t('common.metadata');
  } else if (label === 16) {
    return t('common.classroom');
  } else if (label === 17) {
    return t('common.announcement');
  } else if (label === 18) {
    return t('common.people');
  } else if (label === 19) {
    return t('common.classwork');
  } else if (label === 20) {
    return t('common.grade');
  }
  return t('common.na');
};

const getStatus = (label, t) => {
  if (label === 'PROGRESS') {
    return t('recovery.statusOptions.inProgress');
  } else if (label === 'COMPLETED') {
    return t('recovery.statusOptions.completed');
  } else if (label === 'FAILED') {
    return t('recovery.statusOptions.failed');
  } else if (label === 'PENDING') {
    return t('recovery.statusOptions.pending');
  } else if (label === 'CANCELLED') {
    return t('recovery.statusOptions.cancelled');
  } else if (label === 'CANCELLING') {
    return t('recovery.statusOptions.cancelling');
  } else if (label === 'PARTIALLYSUCCEEDED') {
    return t('recovery.statusOptions.partiallyCompleted');
  }
  return "/"
}

const getRestoreType = (restoreType, t) => {
  if (restoreType == 2) {
    return t('recovery.restores.types.skipExisting');
  } else if (restoreType == 3) {
    return t('recovery.restores.types.overrideOlder');
  } else if (restoreType == 4) {
    return t('recovery.restores.types.overrideAlways');
  } else if (restoreType == 6) {
    return t('recovery.restores.types.merge');
  }

  return t('recovery.restores.types.newFolder');
}

const getTaskStatus = (status, t) => {
  if (status === 0) {
    return t('recovery.statusOptions.notStarted');
  } else if (status === 1) {
    return t('recovery.statusOptions.inProgress');
  } else if (status === 2) {
    return t('recovery.statusOptions.completed');
  } else if (status === 3) {
    return t('recovery.statusOptions.waitingOnOthers');
  } else if (status === 4) {
    return t('recovery.statusOptions.deferred');
  }
  return '';
}

const getJobStatus = (label, t) => {
  if (label === 'IN_PROGRESS') {
    return t('recovery.statusOptions.inProgress');
  } else if (label === 'FINISHED') {
    return t('recovery.statusOptions.completed');
  } else if (label === 'FAILED') {
    return t('recovery.statusOptions.failed');
  } else if (label === 'STARTED') {
    return t('recovery.statusOptions.pending');
  } else if (label === 'CANCELED') {
    return t('recovery.statusOptions.cancelled');
  } else if (label === 'CANCELLING') {
    return t('recovery.statusOptions.cancelling');
  }
  return "/"
}

const getJobSourcetype = (sourceType, t) => {
  if (sourceType == 0) {
    return t('common.userUpperCase');
  } else if (sourceType == 1) {
    return t('common.site');
  } else if (sourceType == 2) {
    return t('recovery.search.labels.team');
  } else if (sourceType == 3) {
    return t('recovery.shareddrive');
  } else if (sourceType == 4) {
    return t('recovery.backups.labels.mailbox');
  } else if (sourceType == 5) {
    return t('recovery.backups.labels.teamFolders');
  } else if (sourceType == 7) {
    return t('common.class');
  }

  return '/'
}

const getJobEventStatus = (status, t) => {
  if (status == -1) {
    return t('recovery.statusOptions.cancelled');
  } else if (status == 0) {
    return t('recovery.statusOptions.all');
  } else if (status == 1) {
    return t('recovery.statusOptions.started');
  } else if (status == 2) {
    return t('recovery.statusOptions.inProgress');
  } else if (status == 3) {
    return t('recovery.statusOptions.finishedUpperCase');
  } else if (status == 4) {
    return t('recovery.statusOptions.failedUpperCase');
  }

  return '/'
}

const getTypeName = (value, t) => {
  if (value === 0) {
    return t('recovery.statusOptions.all');
  }
  if (value === 1) {
    return t('common.backup');
  } else if (value === 2) {
    return t('common.restore');
  } else if (value === 3) {
    return t('common.export');
  } else if (value === 4) {
    return t('common.searchUpperCase');
  } else if (value === 5) {
    return "Refresh Seats"
  } else if (value === 6) {
    return t('common.delete');
  } else if (value === 7) {
    return t('common.s3Setup');
  } else if (value === 8) {
    return t('common.broadcast');
  } else if (value === 9) {
    return t('common.compare');
  } else if (value === 10) {
    return t('common.seeding');
  }
  return "/"
}

const getUserActivityType = (value, t) => {
  if (value === 0) {
    return t('common.all');
  }
  if (value === 1) {
    return t('activityLogs.enums.activateAll');
  } else if (value === 2) {
    return t('activityLogs.enums.unprotectAll');
  } else if (value === 3) {
    return t('activityLogs.enums.refreshSeats');
  } else if (value === 4) {
    return t('activityLogs.enums.enableAutoAdd');
  } else if (value === 5) {
    return t('activityLogs.enums.disableAutoAdd');
  } else if (value === 6) {
    return t('activityLogs.enums.editDomain');
  } else if (value === 7) {
    return t('activityLogs.enums.cancelExport');
  } else if (value === 8) {
    return t('activityLogs.enums.deleteExport');
  } else if (value === 9) {
    return t('activityLogs.enums.createBackup');
  } else if (value === 10) {
    return t('activityLogs.enums.enableDailyBackupStatusNotification');
  } else if (value === 11) {
    return t('activityLogs.enums.disableDailyBackupStatusNotification');
  } else if (value === 12) {
    return t('activityLogs.enums.signIn')
  } else if (value === 13) {
    return t('activityLogs.enums.editBackupActionsInSeatManagement');
  } else if (value === 14) {
    return t('activityLogs.enums.restoreSnapshotSearchSelection');
  } else if (value === 15) {
    return t('activityLogs.enums.exportSnapshotSearchSelection');
  } else if (value === 16) {
    return t('activityLogs.enums.cancelRestore');
  } else if (value === 17) {
    return t('activityLogs.enums.backupAll');
  } else if (value === 18) {
    return t('activityLogs.enums.enableIncludeUnlicensed');
  } else if (value === 19) {
    return t('activityLogs.enums.disableIncludeUnlicensed');
  } else if (value === 20) {
    return t('activityLogs.enums.compare');
  } else if (value === 21) {
    return t('activityLogs.enums.cancelCompare');
  } else if (value === 22) {
    return t('activityLogs.enums.cancelBackup');
  } else if (value === 23) {
    return t('activityLogs.enums.setUpConnection');
  } else if (value === 24) {
    return t('activityLogs.enums.editConnection');
  } else if (value === 25) {
    return t('activityLogs.enums.deleteConnection');
  } else if (value === 26) {
    return t('activityLogs.enums.addRecipient');
  } else if (value === 27) {
    return t('activityLogs.enums.editRecipient');
  } else if (value === 28) {
    return t('activityLogs.enums.deleteRecipient');
  } else if (value === 29) {
    return t('activityLogs.enums.archiveDeletedUsers');
  } else if (value === 30) {
    return t('activityLogs.enums.unprotectDeletedUsers');
  }
  // else if (value === 00000) {
  // return t('activityLogs.enums.createSeedingTemplate');
  // } else if (value === 00000) {
  // return t('activityLogs.enums.enableIncludeInBackup');
  // } else if (value === 00000) {
  // return t('activityLogs.enums.disableIncludeInBackup');
  // }
  return "/"
}

const getReportingModuleName = (value, t, provider = 1) => {
  if (value === 1 && provider == 1) {
    return t('common.Drive');
  } else if (value === 1 && (provider == 2 || provider == 3 || provider == 4)) {
    return t('common.Drive');
  } else if (value === 2 && provider == 1) {
    return t('recovery.exports.dataSets.mail');
  } else if (value == 2 && provider == 2) {
    return t('common.Gmail');
  } else if (value === 3) {
    return t('common.Calendar');
  } else if (value === 4) {
    return t('common.Contacts');
  } else if (value === 5) {
    return t('common.Outlook');
  } else if (value === 6) {
    return t('common.teamsAndGroups');
  } else if (value === 7) {
    return t('common.SharePoint');
  } else if (value === 8 && provider == 3) {
    return t('common.teamFolders');
  } else if (value === 8) {
    return t('common.Shared Drives');
  } else if (value === 9) {
    return t('recovery.exports.dataSets.conversations');
  } else if (value === 10) {
    if (provider == 1) {
      return t('common.Outlook');
    }
    return t('recovery.exports.dataSets.tasks');
  } else if (value === 12) {
    return t('common.classroom');
  } else if (provider == 5) {
    return t('common.salesforce');
  } else if (value === 14 && (provider === 1 || provider === 6)) {
    return t('common.entraId')
  }
  return t('common.na');
}

const getBackupJobModule = (value, provider, sourceType = null, t) => {
  if (sourceType !== null && sourceType === 5 && provider === 3) {
    return t('common.teamFolders');
  } else if (value === 0) {
    if (provider === 1) {
      return t('common.Outlook');
    }
    return t('common.Contacts');
  } else if (value === 1) {
    if (provider === 1) {
      if (sourceType === 2) {
        return t('common.teamsAndGroups');
      }
      return t('common.Outlook');
    }
    return t('common.Calendar');
  } else if (value === 2) {
    if (sourceType === 2) {
      return t('common.teamsAndGroups');
    }
    if (provider === 2) {
      return t('common.Gmail');
    }
    return t('common.Outlook');
  } else if (value === 3 && provider === 1) {
    if (sourceType === 1) {
      return t('common.SharePoint');
    }
    if (sourceType === 2) {
      return t('common.teamsAndGroups');
    }
    return t('common.oneDrive');
  } else if (value === 3 && provider === 2) {
    return t('common.Drive');
  } else if (value === 3 && provider === 3) {
    return t('common.Drive');
  } else if (value === 3 && provider === 4) {
    return t('common.Drive');
  } else if (value === 4 && sourceType == 4) {
    return "Shared Mailboxes"
  } else if (value === 4) {
    return t('common.Outlook');
  } else if ((value === 5) || (value === 11 && sourceType === 2)) {
    return t('common.teamsAndGroups');
  } else if (value === 6) {
    return t('common.SharePoint');
  } else if (value === 7) {
    if (provider === 1) {
      return t('common.SharePoint');
    }
    return t('recovery.exports.dataSets.list');
  } else if (value === 8 && provider === 3) {
    return t('common.userUpperCase');
  } else if (value === 8) {
    return t('common.userUpperCase');
  } else if (value === 9) {
    return t('common.sharedDrives');
  } else if (value === 10) {
    if (provider === 1) {
      return t('common.Outlook');
    }
    return t('recovery.exports.dataSets.tasks');
  } else if (value === 11) {
    return t('common.teamFolders');
  } else if (value === 16 || value === 17 || value === 18 || value === 19 || value === 20) {
    return t('common.classroom');
  } else if (provider === 5 && value === 12) {
    return t('common.salesforce');
  } else if (value === 14) {
    return t('common.teamsAndGroups');
  } else if (value === 15 && (provider === 1 || provider === 6)) {
    return t('common.entraId')
  }
  return "/"
}

const getBackupJobName = (value, provider, sourceType = null, module) => {
  if (sourceType !== null && module === 15 && provider === 1) {
    return "/"
  }

  return value;
}

const getStatusLabel = (status, t) => {
  if (status === -1) {
    return t('common.enums.cancelled');
  } else if (status === 1) {
    return t('common.enums.pending');
  } else if (status === 2) {
    return t('common.enums.inProgress');
  } else if (status === 3) {
    return t('common.enums.completed');
  } else if (status === 4) {
    return t('common.enums.failed');
  }
  return t('common.na');
}

const getTemplateTypes = (templateType, t) => {
  if (templateType === 1) {
    return t('common.nodes');
  } else if (templateType === 2) {
    return t('common.levels');
  }
  return t('common.na');
}

const getActiveStatusConnections = (isActive, t) => {
  if (isActive) {
    return t('common.activeUpperCase');
  } else if (!isActive) {
    return t('common.expired');
  }

  return t('common.na')
}

const getStatusLabels = (status, t) => {
  if (status === 0) {
    return t('common.pendingUpperCase');
  } else if (status === 1) {
    return t('common.progressUpperCase');
  } else if (status === 2) {
    return t('common.completedUpperCase');
  } else if (status === 3) {
    return t('common.failedUpperCase');
  } else if (status === 4) {
    return t('common.canceledUpperCase');
  }
  return t('common.na');
}

const getExportDestinationType = (value, t) => {
  if (value === 0) {
    return t('common.download');
  } else if (value === 1) {
    return t('common.awsS3');
  } else if (value === 2) {
    return t('common.azureBlob');
  } else if (value === 3) {
    return t('common.googleDrive');
  } else if (value === 4) {
    return t('common.microsoftOneDrive');
  } else if (value === 5) {
    return t('common.dropbox');
  } else if (value === 6) {
    return t('common.box');
  } else if (value === 7) {
    return t('common.awsS3Compatible');
  } else if (value === 8) {
    return t('common.googleCloudPlatform');
  } else if (value && value.length > 0) {
    return value
  }

  return t('common.na');
}

export const getTooltip = (item, t) => {
  switch (item.provider) {
    case 'AWS':
      return `${t('common.bucketName')}${item.email || t('common.na')}`;
    case 'AzureBlob':
      return `${t('common.containerName')}${item.email || t('common.na')}`;
    case 'Microsoft':
    case 'Google':
    case 'Box':
    case 'Dropbox':
      return `${t('common.adminEmail')}${item.email || t('common.na')}`;
    default:
      return '';
  }
}

export const getConnectionTypes = (storageDestinationType, t) => {
  if (storageDestinationType === 1) {
    return t('common.awsS3');
  } else if (storageDestinationType === 2) {
    return t('common.azureBlobStorage');
  } else if (storageDestinationType === 3) {
    return t('common.googleDrive');
  } else if (storageDestinationType === 4) {
    return t('common.microsoftOneDrive');
  } else if (storageDestinationType === 5) {
    return t('common.dropbox');
  } else if (storageDestinationType === 6) {
    return t('common.box');
  } else if (storageDestinationType === 7) {
    return t('common.awsS3Compatible');
  } else if (storageDestinationType === 8) {
    return t('common.googleCloudPlatform');
  }

  return t('common.na');
}

export const getCompareStatus = (errorCode, t) => {
  if (errorCode === 0) {
    return t('common.enums.success');
  }

  return errorCode;
};

export const getGroupType = (item, t) => {
  const group = item?.dataObject;
  const groupTypes = group?.groupTypes || [];

  if (groupTypes.some(t => t.toLowerCase() === 'unified')) {
    return 'Microsoft 365';
  } else if (group.securityEnabled === true) {
    return t('common.enums.security');
  } else if (group.mailEnabled === true) {
    return t('common.enums.distribution');
  }

  return t('common.enums.unknown');
};

export const getMembershipType = (item, t) => {
  const group = item?.dataObject;
  const types = group?.groupTypes || [];

  return types.some(t => t.toLowerCase() === 'dynamicmembership') ? t('common.enums.dynamic') : t('common.enums.assigned');
};

const getComparisonEntryStatus = (status, t) => {
  if (status === 1) {
    return t('common.enums.added')
  } else if (status === 2) {
    return t('common.enums.removed')
  } else if (status === 3) {
    return t('common.enums.modified')
  } else if (status === 4) {
    return t('common.enums.unchanged')
  }
  return "NA"
}

export const ProviderTenantType = {
  MICROSOFT: 1,
  GOOGLE: 2,
  DROPBOX: 3,
  BOX: 4,
  SALESFORCE: 5,
  ENTRAID: 6
};

export const getProviderTenantType = (providerUrl) => {
  const key = providerUrl.toUpperCase();

  if (key === 'MICROSOFT' || key === 'OFFICE') {
    return ProviderTenantType.MICROSOFT;
  } else if (key === 'GOOGLE') {
    return ProviderTenantType.GOOGLE;
  } else if (key === 'DROPBOX') {
    return ProviderTenantType.DROPBOX;
  } else if (key === 'BOX') {
    return ProviderTenantType.BOX;
  } else if (key === 'SALESFORCE') {
    return ProviderTenantType.SALESFORCE;
  } else if (key === 'ENTRAID') {
    return ProviderTenantType.ENTRAID;
  }

  return null;
};

const entraIdObjectTypeNameMap = {
  User: 'seats.entraIdObjectTypes.users',
  Group: 'seats.entraIdObjectTypes.groups',
  RoleDefinition: 'seats.entraIdObjectTypes.rolesAndAdministrators',
  AdministrativeUnit: 'seats.entraIdObjectTypes.administrativeUnits',
  Application: 'seats.entraIdObjectTypes.appRegistrations',
  EnterpriseApplication: 'seats.entraIdObjectTypes.enterpriseApplications',
  Device: 'seats.entraIdObjectTypes.devices',
  DeviceConfiguration: 'seats.entraIdObjectTypes.deviceConfiguration',
  DeviceCompliancePolicy: 'seats.entraIdObjectTypes.deviceCompliancePolicy',
  BitLockerRecoveryKey: 'seats.entraIdObjectTypes.deviceBitlockerRecoveryKeys',
  ConditionalAccessPolicy: 'seats.entraIdObjectTypes.policies',
  SignInLog: 'seats.entraIdObjectTypes.signInLog',
  AuditLog: 'seats.entraIdObjectTypes.auditLog',
};

const getObjectTypeLabel = (item, t) => {
  if (entraIdObjectTypeNameMap[item]) {
    return t(entraIdObjectTypeNameMap[item]);
  }
  if (item === 0 || item === "0") {
    return t('seats.entraIdObjectTypes.users');
  } else if (item === 1 || item === "1") {
    return t('seats.entraIdObjectTypes.groups');
  } else if (item === 2 || item === "2") {
    return t('seats.entraIdObjectTypes.rolesAndAdministrators');
  } else if (item === 3 || item === "3") {
    return t('seats.entraIdObjectTypes.administrativeUnits');
  } else if (item === 4 || item === "4") {
    return t('seats.entraIdObjectTypes.appRegistrations');
  } else if (item === 5 || item === "5") {
    return t('seats.entraIdObjectTypes.enterpriseApplications');
  } else if (item === 6 || item === "6") {
    return t('seats.entraIdObjectTypes.devices');
  } else if (item === 7 || item === "7") {
    return t('seats.entraIdObjectTypes.deviceConfiguration');
  } else if (item === 8 || item === "8") {
    return t('seats.entraIdObjectTypes.deviceCompliancePolicy');
  } else if (item === 9 || item === "9") {
    return t('seats.entraIdObjectTypes.deviceBitlockerRecoveryKeys');
  } else if (item === 10 || item === "10") {
    return t('seats.entraIdObjectTypes.policies');
  } else if (item === 11 || item === "11") {
    return t('seats.entraIdObjectTypes.signInLog');
  } else if (item === 12 || item === "12") {
    return t('seats.entraIdObjectTypes.auditLog');
  }
  if (item && typeof item === 'string') return item;
  return t('common.na');
}

export const getExportType = (item, t) => {
  if (item.type === 'Selection') {
    return t('common.enums.selection');
  } else if (item.type === 'Snapshot') {
    return t('recovery.restore.form.snapshot');
  } else if (item.type === 'Search') {
    return t('common.searchUpperCase');
  } else if (item.type === 'Whole Class') {
    return t('recovery.wholeClass');
  }
}

export const getPerformedBy = (item, t) => {
  if (item.performedBy == "system" || item.createdBy == "system") {
    return t('common.enums.system')
  } else return item.performedBy || item.createdBy;
}

export const getExportState = (item, t) => {
  if (item.state === 'ACTIVE') {
    return t('recovery.active');
  } else if (item.state === 'DELETED') {
    return t('recovery.deleted');
  }
  return t('common.na')
}

export const getFolderType = (item, t) => {
  if (item.type === 'Folder') {
    return t('common.folder')
  } else return item.type;
}

export const getDestinationEnum = (item, t) => {
  if (item.destination === 'Download') {
    return t('common.download')
  } else if (item.destination) {
    return item.destination;
  } else return t('common.na')
}

export const getVolumeType = (item, t) => {
  if (item == 1) {
    return t('recovery.operatingSystemValue')
  } else if (item == 2) {
    return t('recovery.fixedDataVolume')
  } else if (item == 3) {
    return t('recovery.removableDataVolume')
  } else if (item == 4) {
    return t('recovery.unknownFutureValue')
  }
}

export const getUserType = (item, t) => {
  if (item == 'Member') {
    return t('common.member')
  } else if (item == 'Guest') {
    return t('common.guest')
  } else return item ?? t('common.na')
}

export const getSignInAudience = (value, t) => {
  if (value === 'AzureADMyOrg') {
    return t('recovery.AzureADMyOrg');
  } else if (value === 'AzureADMultipleOrgs') {
    return t('recovery.AzureADMultipleOrgs');
  } else if (value === 'AzureADandPersonalMicrosoftAccount') {
    return t('recovery.AzureADandPersonalMicrosoftAccount');
  } else {
    return value;
  }
};

export const getCancelCompareMessage = (code, t) => {
  if (code == 0) {
    return t('recovery.comparesPage.compareCanceled');
  } else if (code == 1) {
    return t('recovery.comparesPage.compareAlreadyCompleted');
  } else if (code == 2) {
    return t('recovery.comparesPage.cancellationInProgress');
  } else if (code == 3) {
    return t('recovery.comparesPage.jobNotFound');
  } else if (code == 4) {
    return t('recovery.comparesPage.cannotCancelCompleted');
  } else if (code == 5) {
    return t('recovery.comparesPage.cannotCancelFailed');
  } else if (code == 6) {
    return t('recovery.comparesPage.cannotCancel');
  }

  return t('recovery.comparesPage.compareCanceled');
}

export const getRiskLevel = (code, t) => {
  switch (code) {
    case 0:
      return t('common.enums.low');
    case 1:
      return t('common.enums.medium');
    case 2:
      return t('common.enums.high');
    case 3:
      return t('common.enums.hidden');
    case 4:
      return t('common.enums.none');
    case 5:
      return t('common.enums.unknownFutureValue');
    default:
      return t('common.na');
  }
}

export const getRiskState = (code, t) => {
  switch (code) {
    case 0:
      return t('common.enums.none');
    case 1:
      return t('common.enums.confirmedSafe');
    case 2:
      return t('common.enums.remediated');
    case 3:
      return t('common.enums.dismissed');
    case 4:
      return t('common.enums.atRisk');
    case 5:
      return t('common.enums.confirmedCompromised');
    case 6:
      return t('common.enums.unknownFutureValue');
    default:
      return t('common.na');
  }
}

export const getRiskDetail = (code, t) => {
  switch (code) {
    case 0:
      return t('common.enums.none');
    case 1:
      return t('common.enums.adminGeneratedTemporaryPassword');
    case 2:
      return t('common.enums.userPerformedSecuredPasswordChange');
    case 3:
      return t('common.enums.userPerformedSecuredPasswordReset');
    case 4:
      return t('common.enums.adminConfirmedSigninSafe');
    case 5:
      return t('common.enums.aiConfirmedSigninSafe');
    case 6:
      return t('common.enums.userPassedMFADrivenByRiskBasedPolicy');
    case 7:
      return t('common.enums.adminDismissedAllRiskForUser');
    case 8:
      return t('common.enums.adminConfirmedSigninCompromised');
    case 9:
      return t('common.enums.hidden');
    case 10:
      return t('common.enums.adminConfirmedUserCompromised');
    case 11:
      return t('common.enums.unknownFutureValue');
    case 12:
      return t('common.enums.adminConfirmedServicePrincipalCompromised');
    case 13:
      return t('common.enums.adminDismissedAllRiskForServicePrincipal');
    case 14:
      return t('common.enums.m365DAdminDismissedDetection');
    default:
      return t('common.na');
  }
}

export const getAppliedConditionalAccessPolicyResult = (code, t) => {
  if (code == 0) return t('common.enums.success');
  if (code == 1) return t('common.enums.failure');
  if (code == 2 || code === null || code === undefined) return t('common.na');
  if (code == 3) return t('common.enums.notEnabled');
  if (code == 4) return t('common.enums.unknown');
  if (code == 5) return t('common.enums.unknownFutureValue');
  return t('common.na');
}

export const getConditionalAccessStatus = (code, t) => {
  if (code == 0) {
    return t('common.enums.success');
  } else if (code == 1) {
    return t('common.enums.failed');
  } else if (code == 2) {
    return t('common.enums.notApplied');
  } else if (code == 3) {
    return t('common.enums.unknownFutureValue');
  }

  return t('common.na');
}

export {
  SEAT_STATUS,
  SEAT_STATUS_ACTIONS,
  getAlternativesForStatus,
  getEnumLabel,
  getDataSetLabel,
  getStatus,
  getTaskStatus,
  getJobStatus,
  getJobSourcetype,
  getJobEventStatus,
  getTypeName,
  getUserActivityType,
  getRestoreType,
  getReportingModuleName,
  getBackupJobModule,
  getBackupJobName,
  getStatusLabel,
  getTemplateTypes,
  getStatusLabels,
  getExportDestinationType,
  getActiveStatusConnections,
  getComparisonEntryStatus,
  getObjectTypeLabel
}
